import React, { FC } from 'react';

import * as St from './GlobalContentLayout.styles';

export const GlobalContentLayout: FC<any> = ({ children, className, ...props }) => (
  <St.Wrapper className={className} {...props}>
    {children}
  </St.Wrapper>
);
